import { createUseStyles } from 'react-jss';

const styles = {
  div: {
    display: 'flex',
    marginBottom: '1rem'
  },
  label: {
    paddingRight: '0.3rem',
    minWidth: '8rem',
    textAlign: 'right',
    alignItems: 'center'
  },
  filterBar: {
    '& ui5-label': {
      marginBottom: '0.3rem'
    }
  },
  filterDiv: {
    padding: '1rem 3rem 0 3rem'
  },
  queryTable: {
    width: '100%'
  },
  queryCell: {
    maxWidth: '40rem',
    minWidth: '3rem',
    height: '3rem'
  },
  container: {
    margin: '0 15%'
  },
  queryTitleArea: {
    width: '100%',
    marginTop: '0.3rem'
  },
  actionGroup: {
    justifyContent: 'flex-end'
  },
  actionGroupItem: {
    margin: '0.2rem'
  },
  busyIndicator: {
    width: '100%',
    background: 'transparent'
  },
  tableHeaderDiv: {
    padding: '0.5rem 3rem 0.5rem 3rem',
    labelSpanS: '12',
    labelSpanM: '2',
    LabelSpanL: '4'
  },
  tableDiv: {
    margin: '0 3rem',
    overflow: 'auto',
    height: 'auto'
  },
  tableRow: {
    cursor: 'pointer'
  },
  tableColumnId: {
    width: '5rem'
  },
  tableColumnDeadline: {
    width: '8rem'
  },
  afterTableDiv: {
    marginTop: '0.3rem',
    marginBottom: '0.3rem'
  },
  fetchItemsButton: {
    display: 'block',
    margin: '0 auto',
    width: '9rem'
  },
  alignRight: {
    marginRight: '3%',
    float: 'right'
  },
  popoverListIcon: {
    boxSizing: 'border-box',
    marginRight: '10px',
    color: '#0854a0'
  },
  popoverListText: { color: '#0854a0 !important' },
  popoverListItem: {
    height: '2rem',
    cursor: 'pointer',
    '&:hover': {
      background: '#f0f0f0 !important'
    }
  },
  statusCell: {
    whiteSpace: 'nowrap',
    maxWidth: '40rem',
    minWidth: '3rem',
    height: '3rem'
  }
};

export const useStyles = createUseStyles(styles, {
  name: 'ManageQueries'
});
